export const CLINIC_TYPES = {
	ALLERGY: 'ALLERGY',
	DEMO: 'DEMO',
	OCCUPATIONAL_MEDICINE: 'OCCUPATIONAL_MEDICINE',
	ONLINE: 'ONLINE',
	RESEARCH: 'RESEARCH',
	UNIVERSITY: 'UNIVERSITY',
	URGENT_CARE: 'URGENT_CARE',
} as const;

export type ClinicType = (typeof CLINIC_TYPES)[keyof typeof CLINIC_TYPES];

export const CLINIC_TYPES_WITHOUT_XRAY = [CLINIC_TYPES.UNIVERSITY] as const;

export const shouldShowInjuryNotification = (clinicType?: string): boolean => {
	if (!clinicType) return false;
	return CLINIC_TYPES_WITHOUT_XRAY.includes(clinicType as (typeof CLINIC_TYPES_WITHOUT_XRAY)[number]);
};
